import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { calcRem, colors, fonts, metrics } from '../../../__styling'

export const StyledUpLateButton = styled('button')({
    // BUTTON STYLING
    background: tokens.thenightly.colors.palette.uplate.default,
    padding: calcRem(
        metrics.thenightly.margins.sm2l,
        metrics.thenightly.margins.m2l,
    ),
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    borderRadius: calcRem(8),
    border: 0,
    color: colors.white,
    display: 'flex',

    '&:active, &:hover, &:focus': {
        background: tokens.thenightly.colors.palette.uplate.hover,
        cursor: 'pointer',
    },

    // FONT STYLING
    fontFamily: fonts.thenightly.navigation,
    fontSize: metrics.thenightly.baseFontSize,
    fontWeight: 600,
    lineHeight: calcRem(24),
    textTransform: 'uppercase',
})
